import {
  faEnvelopeOpen,
  faFileAlt,
  faMinus,
  faPlus,
  faSearch,
} from "@fortawesome/fontawesome-free-solid";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PDFExport } from "@progress/kendo-react-pdf";
import * as EmailValidator from "email-validator";
import DownloadFile from "js-file-download";
import _ from "lodash";
import * as qs from "query-string";
import React, { Component, Fragment } from "react";
import BlockUi from "react-block-ui";
import ReCAPTCHA from "react-google-recaptcha";
import LaddaButton, { ZOOM_IN } from "react-ladda";
import Loader from "react-loaders";
import PerfectScrollbar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { bindActionCreators } from "redux";
import Rodal from "rodal";
import LogoHD from "../../../../assets/utils/images/logo-hd.png";
import { RECAPTCHA_SITE_KEY } from "../../../../config/configKeys";
import { EMAIL_LOGO_IMG_URL } from "../../../../config/configURL";
import {
  setEmailAddressAction,
  setEmailModalVisibleAction,
  setRecaptchaStatusAction,
  setSearchTermAction,
  setShowGroupModal,
} from "../../../../reducers/ui/search";
import {
  apiMonitorSearchRecordToggleAction,
  apiSearchRecordAction,
  apiSendUserEmailAction,
} from "../../../../sagas/apiCallSaga";
import { API_LIST } from "../../../../utils/api";
import {
  PhoneNumberRoamingStatus,
  SearchDataType,
} from "../../../../utils/const";
import {
  checkUIBlock,
  getPortName,
  showError,
  showSuccess,
  showWarning,
} from "../../../../utils/service";
import SearchResultByASN from "../SearchResult/SearchResultByASN";
import SearchResultByDomain from "../SearchResult/SearchResultByDomain";
import SearchResultByIP from "../SearchResult/SearchResultByIP";
import SearchResultByPhone from "../SearchResult/SearchResultByPhone";
import SearchResultEmailByASN from "../SearchResultEmail/SearchResultEmailByASN";
import SearchResultEmailByDomain from "../SearchResultEmail/SearchResultEmailByDomain";
import SearchResultEmailByIP from "../SearchResultEmail/SearchResultEmailByIP";
import SearchResultEmailByPhone from "../SearchResultEmail/SearchResultEmailByPhone";
import { getClientIp } from "./api";

import  {
  EVENTS as MonitoredItemGroupModalEvent,
} from "../../../MyPages/MonitorHistoryV2/Components/MonitoredItemGroupModal";

import MonitoredItemModal from "../../../MyPages/MonitorHistoryV2/Components/MonitoredItemModal"

const mapStateToProps = (store) => ({
  state: store.ui.search,
  account: store.entity.account,
  apiCallData: store.apiCallData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSearchTerm: setSearchTermAction,
      searchRecord: apiSearchRecordAction,
      setEmailModalVisible: setEmailModalVisibleAction,
      setEmailAddress: setEmailAddressAction,
      sendEmail: apiSendUserEmailAction,
      setRecaptchaStatus: setRecaptchaStatusAction,
      setMonitorData: apiMonitorSearchRecordToggleAction,
      setShowGroupModal: setShowGroupModal,
    },
    dispatch
  );

let initialLoad = true;

class SearchComponent extends Component {
  pdfExportComponent;
  recaptchaRef = React.createRef();

  componentDidMount() {
    if (initialLoad) {
      getClientIp({ include_threat_score: true })
        .then((response) => {
          const data = response.data;
          this.props.setSearchTerm(data.ip);
          this.props.searchRecord(data.ip);
          initialLoad = false;
        })
        .catch(console.error);
    }
  }

  getSearchTime = () => {
    let time = new Date(_.now());
    return time.toLocaleString();
  };

  getSearchResultComponent = () => {
    const { searchData } = this.props.state;
    let searchResult = <div></div>;

    if (undefined !== searchData) {
      if (true !== searchData.success) {
        searchResult = <h2>No Result Found</h2>;
      } else {
        switch (searchData.type) {
          case SearchDataType.IP:
            searchResult = (
              <SearchResultByIP data={searchData.data.record_item} />
            );
            break;
          case SearchDataType.ASN:
            searchResult = (
              <SearchResultByASN data={searchData.data.record_item} />
            );
            break;
          case SearchDataType.DOMAIN:
            searchResult = (
              <div>
                <SearchResultByDomain
                  data={searchData.data.record_item.domains}
                  threat_item={searchData.data.threat_item}
                  record_item={searchData.data.record_item}
                />
              </div>
            );
            break;
          case SearchDataType.PHONE_NUMBER:
            searchResult = (
              <SearchResultByPhone
                data={searchData.data.record_item.phone_data}
              />
            );
            break;
          default:
            searchResult = <h3>Unknown Data Format</h3>;
        }
      }
    }

    return searchResult;
  };

  getSearchResultEmailContent = () => {
    const { searchData } = this.props.state;

    if (undefined === searchData) return <div></div>;

    let emailResult = <div></div>;

    switch (searchData.type) {
      case SearchDataType.IP:
        emailResult = (
          <SearchResultEmailByIP data={searchData.data.record_item} />
        );
        break;
      case SearchDataType.ASN:
        emailResult = (
          <SearchResultEmailByASN data={searchData.data.record_item} />
        );
        break;
      case SearchDataType.DOMAIN:
        emailResult = (
          <SearchResultEmailByDomain
            data={searchData.data.record_item.domains}
          />
        );
        break;
      case SearchDataType.PHONE_NUMBER:
        emailResult = (
          <SearchResultEmailByPhone
            data={searchData.data.record_item.phone_data}
          />
        );
        break;
    }

    return emailResult;
  };

  btnSearchClicked = () => {
    const { isAuthenticated } = this.props.account;

    if (isAuthenticated) {
      const { searchTerm } = this.props.state;
      if (searchTerm) {
        this.props.searchRecord(searchTerm);
      }
    } else {
      this.props.setRecaptchaStatus(true);
      this.recaptchaRef.current.execute();
    }
  };

  btnDownloadPdfClicked = () => {
    this.pdfExportComponent.save();
  };

  btnMonitorClicked = () => {
    const { searchData } = this.props.state;
    if (searchData !== undefined && searchData.data) {
      this.props.setMonitorData(searchData.data.id);
    }
  };

  btnSendEmailClicked = () => {
    this.props.setEmailModalVisible(true);
  };

  btnSendMailOKClicked = () => {
    let emailContent = document.getElementById(
      "search_email_content"
    ).innerHTML;
    const { emailAddress } = this.props.state;

    if (!EmailValidator.validate(emailAddress)) {
      showWarning("Please input valid email address.");
      return;
    }

    this.props.sendEmail(emailAddress, emailContent, () => {
      showSuccess("Email was sent");
      this.props.setEmailModalVisible(false);
    });
  };

  getIPSearchResultText = (data) => {
    let res = "";

    res += `##### Search Result for IP : ${data.ip_addr} #####\n`;
    res += `\n\n### IP Information###\n`;
    res += `Location : ${[
      data.city,
      data.state,
      data.country_name,
      data.postal_code,
    ]
      .filter((x) => x)
      .join(", ")}\n`;
    res += `Latitude : ${data.latitude}, Longitude: ${data.longitude}\n`;
    res += `Risk Level : ${data.risk_level}\n`;
    res += `Threat : ${data.threat}\n`;
    res += `Area Code : ${data.area_code}\n`;
    res += `DMA Code : ${data.dma_code}\n`;
    res += `Region Code : ${data.region_code}\n`;
    res += `Organization : ${data.organization}\n`;
    res += `Internet Service Provider : ${data.isp}\n`;
    res += `Operating System : ${data.os}\n`;
    res += `Discover Date : ${data.discover_date}\n`;
    res += `Connection Type : ${data.connection_type}\n`;
    res += `ASN : ${data.as_number}\n`;
    res += `ASN BGP Prefix : ${data.as_bgp_prefix}\n`;
    res += `ASN CC : ${data.as_country_code}\n`;
    res += `ASN Registry : ${data.as_registry}\n`;
    res += `ASN Allocated : ${data.as_allocated_date}\n`;
    res += `ASN Organization : ${data.as_organization}\n`;
    res += `ASN Name : ${data.as_name}\n`;

    if (data.peer_asns.length > 0) {
      res += `\n\n### Peer ASNs ###\n`;
      res += `ASN\t| BGP Prefix\t| Registry\t| Allocated\t| Name\n`;
      data.peer_asns.forEach((item) => {
        res += `${item.as_number}\t| ${item.as_bgp_prefix}\t| ${item.as_registry}\t| ${item.as_allocated_date}\t| ${item.as_name}\n`;
      });
    }

    if (data.domains.length > 0) {
      res += `\n\n### Domains ###\n`;
      data.domains.forEach((domain) => {
        res += `${domain}\n`;
      });
    }

    if (data.host_names.length > 0) {
      res += `\n\n### Host Names ###\n`;
      res.host_names.forEach((name) => {
        res += `${name}\n`;
      });
    }

    if (data.open_ports.length > 0) {
      res += `\n\n### Opened Ports ###\n`;
      data.open_ports.forEach((port) => {
        res += `${port} : ${getPortName(port)}\n`;
      });
    }

    return res;
  };

  getDomainContactResultText = (contact) => {
    let res = "";
    res += `Name : ${contact.name}\n`;
    if (contact.email) {
      res += `Email : ${contact.email}\n`;
    }
    if (contact.organization) {
      res += `Organization : ${contact.organization}\n`;
    }
    if (contact.phone_number) {
      res += `Phone Number : ${contact.phone_number}\n`;
    }
    
    
    res += `Location : ${[
      contact.street,
      contact.city,
      contact.state,
      contact.country_name,
      contact.postal_code,
    ]
      .filter((x) => x)
      .join(", ")}\n`;
    
    return res;
  };

  formatDateEvent = (dateExample) => {
    const dateFinal = new Date(dateExample);
    const finalResult = dateFinal.getFullYear()+'-' + (dateFinal.getMonth()+1) + '-'+dateFinal.getDate() + " "+ dateFinal.getHours()+":"+dateFinal.getMinutes()+":"+dateFinal.getSeconds();
    return finalResult;
  }

  stringFormatUppercase = (word) => {
    const string_final = word[0].toUpperCase() + word.substr(1);

    return string_final;
  };

  getDomainSearchResultText = (data) => {
    let res = "";

    res += `##### Search Result for Domain : ${data.domain_name} #####\n`;

    res += `\n\n### Domain Information ###\n`;
    res += `Registrar Name : ${data.registrar_name}\n`;
    res += `Registrar IANAID : ${data.registrar_ianaid}\n`;
    if (data.domain_age) {
      res += `Domain Age : ${data.domain_age} (days)\n`;
    }
    res += `Contact Email : ${data.contact_email}\n`;
    res += `Created Date : ${data.created_date}\n`;
    res += `Updated Date : ${data.updated_date}\n`;
    res += `Expires Date : ${data.expires_date}\n`;
    res += `Status : ${data.status}\n`;
    if (data.whois_server) {
      res += `WhoIsServer : ${data.whois_server}\n`;
    }

    if (data.registrant) {
      res += `\n\n### Registrant ### \n`;
      res += this.getDomainContactResultText(data.registrant);
    }

    if (data.administrative_contact) {
      res += `\n\n### Administrative Contact ###\n`;
      res += this.getDomainContactResultText(data.administrative_contact);
    }

    if (data.technical_contact) {
      res += `\n\n### Technical Contact ###\n`;
      res += this.getDomainContactResultText(data.technical_contact);
    }

    if (data.name_servers) {
      res += `\n\n### Name Servers ###\n`;
      res += `- Host Names\n`;
      data.name_servers.host_names.forEach((item) => {
        res += `${item}\n`;
      });
      res += `- IPs\n`;
      data.name_servers.ips.forEach((item) => {
        res += `${item}\n`;
      });
    }

    if (data?.records?.a?.length > 0) {
      res += `\n\n### A Records ###\n`;
      data.records.a.forEach((item) => {
        res += `${item.data}\n`;
      });
    }

    if (data?.records?.mx?.length > 0) {
      res += `\n\n### MX Records ###\n`;
      data.records.mx.forEach((item) => {
        res += `${item.data}\n`;
      });
    }

    if (data?.records?.cname?.length > 0) {
      res += `\n\n### CNAME Records ###\n`;
      data.records.cname.forEach((item) => {
        res += `${item.data}\n`;
      });
    }

    if (data.nameservers) {
      res += `\n\n### Name Servers ###\n`;
      res += `- Host Names -\n`;
      data.nameservers.forEach((item) => {
        res += `HostName : ${item.ldhName}\n`;
      });
    }

    if (data?.links?.length > 0) {
      res += `\n\n### LINKS ###\n`;
      data?.links?.forEach((item) => {
        res += `${this.stringFormatUppercase(item.rel)} : ${item.value}\n`;
      });
    }

    if (data?.events?.length > 0) {
      res += `\n\n### EVENTS ###\n`;
      data?.events?.forEach((item) => {
        res += `${this.stringFormatUppercase(item.eventAction)} : ${this.formatDateEvent(item.eventDate)}\n`;
      });
    }

    if (data?.notices?.length > 0) {
      res += `\n\n### NOTICES ###\n`;
      data?.notices?.forEach((item) => {
        res += `Title : ${item.title}\n`;
        res += `Description : ${item.description}\n`;
        res += `Link : ${item?.links[0]?.href}\n\n`;
      });
    }

    return res;
  };

  getASNSearchResultText = (data) => {
    let res = "";

    res += `##### Search Result for ASN : ${data.as_number} #####\n`;
    res += `ASN : ${data.as_number}\n`;
    res += `ASN CC : ${data.as_country_code}\n`;
    res += `ASN Registry : ${data.as_registry}\n`;
    res += `ASN Allocated : ${data.as_allocated_date}\n`;
    res += `ASN Name : ${data.as_name}\n`;

    return res;
  };

  getPhoneSearchResult = (data) => {
    let res = "";

    const { roaming, current_carrier, original_carrier } = data;

    res += `##### Search Result for Phone Number : ${data.international_format_number} #####\n\n`;
    res += `International Number : ${data.international_format_number}\n`;
    res += `National Number : ${data.national_format_number}\n`;
    res += `Country Name : ${data.country_name}\n`;
    res += `Country Prefix : ${data.country_prefix}\n`;
    res += `Valid : ${data.valid_number}\n`;
    res += `Request Price : ${data.request_price}\n`;
    res += `Remaining Balance : ${data.remaining_balance}\n`;
    res += `Reachable : ${data.reachable}\n`;
    res += `Ported : ${data.ported}\n`;
    res += `IP Warnings : ${data.ip_warnings}\n`;
    res += `Roaming : ${roaming.status}\n`;

    if (PhoneNumberRoamingStatus.ROAMING === roaming.status) {
      res += `\n\n### Roaming ###\n`;
      res += `Country Code : ${roaming.roaming_country_code}\n`;
      res += `Network Code : ${roaming.roaming_network_name}\n`;
      res += `Network Name : ${roaming.roaming_network_name}\n`;
    }

    if (current_carrier) {
      res += `\n\n### Current Carrier ###\n`;
      res += `Name : ${current_carrier.name}\n`;
      res += `Country : ${current_carrier.country}\n`;
      res += `Network Code : ${current_carrier.network_code}\n`;
      res += `Network Type : ${current_carrier.network_type}\n`;
    }

    if (original_carrier) {
      res += `\n\n### Original Carrier ###\n`;
      res += `Name : ${original_carrier.name}\n`;
      res += `Country : ${original_carrier.country}\n`;
      res += `Network Code : ${original_carrier.network_code}\n`;
      res += `Network Type : ${original_carrier.network_type}\n`;
    }

    return res;
  };

  btnDownloadTxtClicked = () => {
    const { searchData } = this.props.state;
    let downloadText = "";

    if (undefined !== searchData && true === searchData.success) {
      switch (searchData.type) {
        case SearchDataType.IP:
          downloadText = this.getIPSearchResultText(
            searchData.data.record_item
          );
          break;
        case SearchDataType.ASN:
          downloadText = this.getASNSearchResultText(
            searchData.data.record_item
          );
          break;
        case SearchDataType.DOMAIN:
          downloadText = this.getDomainSearchResultText(
            searchData.data.record_item.domains
          );
          break;
        case SearchDataType.PHONE_NUMBER:
          downloadText = this.getPhoneSearchResult(
            searchData.data.record_item.phone_data
          );
          break;
      }
    }

    downloadText += "\n\n\nResult from cyberspf.com\n";

    DownloadFile(downloadText, "search_result.txt");
  };

  changeReCaptchaValue = (value) => {
    if (null === value) {
      this.props.setRecaptchaStatus(false);
      showError("Please try again");
      return;
    }
    const { searchTerm } = this.props.state;
    this.props.setRecaptchaStatus(false);
    this.props.searchRecord(searchTerm, value);
  };

  render() {
    const { isAuthenticated } = this.props.account;
    const {
      searchTerm,
      emailModalVisible,
      emailAddress,
      recaptchaStatus,
      monitor,
    } = this.props.state;
    const { apiCallData } = this.props;
    let monitorIcon = faPlus;
    if (monitor) {
      monitorIcon = faMinus;
    }
    const { location, history } = this.props;
    if (location.search) {
      const parsed = qs.parse(location.search);
      if (parsed.search) {
        if (searchTerm !== parsed.search) {
          this.props.setSearchTerm(parsed.search);
          this.props.searchRecord(parsed.search);
        }
      }
    }

    return (
      <Fragment>
        {this.props.state.searchData && this.props.state.searchData.data ? (
          <MonitoredItemModal
            isOpen={this.props.state.showGroupModal}
            selectedItem={{ id: this.props.state.searchData.data.id , alert_method: this.props.state.searchData.data.alert_method}}
            onModalEvent={(event, _) => {
              if (event === MonitoredItemGroupModalEvent.CANCEL[0]) {
                this.props.setShowGroupModal(false);
              }
            }}
          />
        ) : (
          <></>
        )}

        <Row>
          <Col lg={{ size: 10, offset: 1 }}>
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="IP Address, Domain, AS Number, Phone Number"
                className=""
                value={searchTerm}
                onChange={(e) => {
                  history.replace({
                    search: "",
                  });
                  this.props.setSearchTerm(e.target.value);
                }}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    if (searchTerm !== "") {
                      history.replace({
                        search: "",
                      });
                      this.btnSearchClicked();
                    }
                  }
                }}
              />
              <InputGroupAddon addonType="append">
                <LaddaButton
                  className="btn btn-shadow btn-focus"
                  loading={
                    checkUIBlock(apiCallData[API_LIST.SEARCH_RECORD.ID]) ||
                    recaptchaStatus
                  }
                  onClick={() => {
                    history.replace({
                      search: "",
                    });
                    this.btnSearchClicked();
                  }}
                  disabled={"" === searchTerm}
                  data-style={ZOOM_IN}
                >
                  Search
                </LaddaButton>
              </InputGroupAddon>
            </InputGroup>
          </Col>
        </Row>
        {isAuthenticated ? (
          <div />
        ) : (
          <ReCAPTCHA
            ref={this.recaptchaRef}
            sitekey={RECAPTCHA_SITE_KEY}
            onChange={this.changeReCaptchaValue}
            size="invisible"
          />
        )}
        <Card className="main-card mt-4 mb-4">
          <CardHeader>
            Search Result
            <div className="btn-actions-pane-right actions-icon-btn">
              <ButtonGroup>
                <Button
                  className="btn-icon"
                  outline
                  color="secondary"
                  onClick={this.btnDownloadPdfClicked}
                >
                  <FontAwesomeIcon
                    icon={faFilePdf}
                    className="btn-icon-wrapper"
                  />
                  PDF
                </Button>
                <Button
                  className="btn-icon"
                  outline
                  color="secondary"
                  onClick={this.btnDownloadTxtClicked}
                >
                  <FontAwesomeIcon
                    icon={faFileAlt}
                    className="btn-icon-wrapper"
                  />
                  TXT
                </Button>
                <Button
                  className="btn-icon"
                  outline
                  color="secondary"
                  onClick={this.btnSendEmailClicked}
                >
                  <FontAwesomeIcon
                    icon={faEnvelopeOpen}
                    className="btn-icon-wrapper"
                  />
                  Email
                </Button>
                <Button
                  className="btn-icon"
                  outline
                  color="secondary"
                  onClick={this.btnMonitorClicked}
                >
                  <FontAwesomeIcon
                    icon={monitorIcon}
                    className="btn-icon-wrapper"
                  />
                  Monitor
                </Button>
              </ButtonGroup>
            </div>
          </CardHeader>
          <CardBody style={{ minHeight: 500, overflow: "hidden" }}>
            <div style={{ marginTop: -180 }}>
              <PDFExport
                pageSize="A4"
                margin="2cm"
                ref={(component) => (this.pdfExportComponent = component)}
              >
                <h5 className="text-right">{this.getSearchTime()}</h5>
                <div className="mb-5">
                  <img src={LogoHD} height={100} />
                </div>
                {this.getSearchResultComponent()}
              </PDFExport>
            </div>
          </CardBody>
        </Card>
        <Rodal
          visible={emailModalVisible}
          onClose={() => {
            this.props.setEmailModalVisible(false);
          }}
          animation={"flip"}
          showMask={false}
          width={640}
        >
          <BlockUi
            tag="div"
            blocking={checkUIBlock(apiCallData[API_LIST.SEND_USER_EMAIL.ID])}
            className="block-overlay-dark"
            loader={
              <Loader color="#ffffff" active type={"ball-spin-fade-loader"} />
            }
          >
            <ModalHeader>Preview Email</ModalHeader>
            <ModalBody className="pb-0">
              <div className="scroll-area-md">
                <PerfectScrollbar>
                  <div id="search_email_content">
                    <style
                      dangerouslySetInnerHTML={{
                        __html: `
                        .email-container {
                          width: 600px;
                        }

                        .email-container table {
                          width: 100%;
                        }

                        .email-container tr {
                          border-bottom: solid 1px #000;
                        }

                        .email-container td {
                          border-bottom: solid 1px #000;
                        }

                        .email-container h3 {
                          text-align: center;
                          text-decoration: underline;
                        }
                      `,
                      }}
                    />
                    <div>
                      <img src={EMAIL_LOGO_IMG_URL} style={{ maxWidth: 600 }} />
                    </div>
                    {this.getSearchResultEmailContent()}
                  </div>
                </PerfectScrollbar>
              </div>
              <FormGroup className="mt-4">
                <Input
                  type="text"
                  placeholder="Please input email address..."
                  value={emailAddress}
                  onChange={(e) => this.props.setEmailAddress(e.target.value)}
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                onClick={() => this.props.setEmailModalVisible(false)}
              >
                Cancel
              </Button>
              <Button color="info" onClick={this.btnSendMailOKClicked}>
                Send Email
              </Button>
            </ModalFooter>
          </BlockUi>
        </Rodal>
      </Fragment>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SearchComponent));
